export const NOTIFICATION_MANAGEMENT_LIST = 'NOTIFICATION_MANAGEMENT_LIST';
export const NOTIFICATION_MANAGEMENT_LIST_SUCCESS = 'NOTIFICATION_MANAGEMENT_LIST_SUCCESS';
export const NOTIFICATION_MANAGEMENT_LIST_ERROR = 'NOTIFICATION_MANAGEMENT_LIST_ERROR';

export const ADD_NOTIFICATION_TYPE = 'ADD_NOTIFICATION_TYPE';
export const ADD_NOTIFICATION_TYPE_SUCCESS = 'ADD_NOTIFICATION_TYPE_SUCCESS';
export const ADD_NOTIFICATION_TYPE_ERROR = 'ADD_NOTIFICATION_TYPE_ERROR';

export const NOTIFICATION_MANAGEMENT_DETAILS = 'NOTIFICATION_MANAGEMENT_DETAILS';
export const NOTIFICATION_MANAGEMENT_DETAILS_SUCCESS = 'NOTIFICATION_MANAGEMENT_DETAILS_SUCCESS';
export const NOTIFICATION_MANAGEMENT_DETAILS_ERROR = 'NOTIFICATION_MANAGEMENT_DETAILS_SUCCESS_ERROR';

export const NOTIFICATION_MANAGEMENT_UPDATE = 'NOTIFICATION_MANAGEMENT_UPDATE';
export const NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS = 'NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS';
export const NOTIFICATION_MANAGEMENT_UPDATE_ERROR = 'NOTIFICATION_MANAGEMENT_UPDATE_ERROR';

export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const DELETE_NOTIFICATION_ERROR = 'DELETE_ASSETS_ERROR';
export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';